import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable, startWith, debounceTime, distinctUntilChanged, switchMap, of, Subject } from 'rxjs';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { FrotaService } from '../frota.service';
import { IFiltroFrotaModel, IFrotaModel } from '../model/frota.model';
import { PesquisaFrotaComponent } from '../pesquisa-frota/pesquisa-frota.component';

@Component({
  selector: 'app-filtro-frota',
  templateUrl: './filtro-frota.component.html',
  styleUrls: ['./filtro-frota.component.scss']
})
export class FiltroFrotaComponent implements OnInit, OnDestroy {

  @Output() onFrotaSelected = new EventEmitter<IFrotaModel | null>();

  filtro !: IFiltroFrotaModel;

  filteredOptions!: Observable<any>;

  search$ = new Subject<string>();

  constructor(private frotaService: FrotaService, public dialog: MatDialog, private snackBar: SnackBarService) {

    this.filtro = { guid: this.frotaService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }

  ngOnInit(): void {
    if (this.frotaService.usuario == null) {
      this.snackBar.flashMessage('Sessão expirada. Favor logar novamente no sistema.', ['snackbar-error'], 'Fechar', 0);
    }
    else {

      this.filteredOptions = this.search$
        .pipe(
          startWith(''),
          debounceTime(400),
          distinctUntilChanged(),
          switchMap(val => {
            return this.filter(val || '')
          })
        );

      if (sessionStorage.getItem('filtroFrota')) {
        var localFiltro = JSON.parse(sessionStorage.getItem('filtroFrota') ?? '{}');
        if (localFiltro.guid === this.filtro.guid) {
          this.filtro = localFiltro;
        } else {
          sessionStorage.removeItem('filtroFrota');
        }
      }
    }
  }

  filter(val: string): Observable<any[]> {

    if (!val.length || val.length < 2) {
      return of([]);
    }
    // call the service which makes the http-request
    var filtro = { conteudo: val, guid: this.frotaService.usuario.retorno.guid };
    return this.frotaService.searchFrota(filtro).pipe(map(response => { return response.retorno }));
  }

  displayFn(frota: IFrotaModel): string {
    return frota && frota.busca ? frota.busca : '';
  }

  onSubmit(): void {
    const dialogRef = this.dialog.open(PesquisaFrotaComponent, { width: '800px', height: '700px', data: { dataKey: structuredClone(this.filtro) } }).afterClosed()
      .subscribe(response => {
        if (response && response.data) {
          this.filtro.frota = response.data;
          this.onFrotaSelected.emit(this.filtro.frota);
        }
      });;
  }

  getPosts(selectFrota: IFrotaModel) {
    this.filtro.frota = selectFrota;
    this.filtro.parametro = '';
    this.onFrotaSelected.emit(this.filtro.frota);
  }

  limpaFiltro() {
    this.filtro.frota = undefined;
    this.onFrotaSelected.emit(this.filtro.frota);
    sessionStorage.removeItem('filtroFrota');
    this.filtro = { guid: this.frotaService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }

  ngOnDestroy() {
    sessionStorage.setItem('filtroFrota', JSON.stringify(this.filtro));
  }

}